//Buyerszone Title and Description
import { useEffect, useState } from 'react';
import { getMethod } from '../../services/apiService';
import LoadingSpinner from '../../utility/LoadingSpinner';

const Buyerszone = () => {
  const [latestEntry, setLatestEntry] = useState(null);
  const [loading, setLoading] = useState(true);

  //Display buyerszone content
  useEffect(() => {
    const getBuyerszone = async () => {
      try {
        const response = await getMethod('welcome');
        if (!response.error && response.data) {
          const data = response.data;
          if (Array.isArray(data) && data.length > 0) {
            const lastItem = data[data.length - 1];
            setLatestEntry(lastItem);
            localStorage.setItem('welcomeContent', JSON.stringify(lastItem));
          } else if (data.title && data.description) {
            setLatestEntry(data);
            localStorage.setItem('welcomeContent', JSON.stringify(data));
          }
        } else {
          const storedContent = localStorage.getItem('welcomeContent');
          if (storedContent) {
            setLatestEntry(JSON.parse(storedContent));
          }
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching welcome content:', error);
        const storedContent = localStorage.getItem('welcomeContent');
        if (storedContent) {
          setLatestEntry(JSON.parse(storedContent));
        }
      }
    };

    getBuyerszone();
  }, []);

  if (loading) return <LoadingSpinner />;

  return (
    <div>
      <section >
        <h1 className="buyerszoneheader"
          dangerouslySetInnerHTML={{ __html: latestEntry.buyers_title }}>
        </h1>

      </section>

      <section>
        <div className="buyerszonediv"
          dangerouslySetInnerHTML={{ __html: latestEntry.buyers_description }}
        />
      </section>
    </div>
  );
};

export default Buyerszone;